import { BaseGameType } from 'game-ui-types'
import { slotConfigA } from './slotConfigA'
import { slotConfigB } from './slotConfigB'
import { slotConfigC } from './slotConfigC'
import { slotConfigD } from './slotConfigD'
import { slotConfigE } from './slotConfigE'
import { slotConfigF } from './slotConfigF'
import { BaseGameConfigurations } from './types'

const gameConfigurations: BaseGameConfigurations = {
    [BaseGameType.SLOT_CONFIG_A]: {
        viewports: slotConfigA,
    },
    [BaseGameType.SLOT_CONFIG_B]: {
        viewports: slotConfigB,
    },
    [BaseGameType.SLOT_CONFIG_C]: {
        viewports: slotConfigC,
    },
    [BaseGameType.SLOT_CONFIG_D]: {
        viewports: slotConfigD,
    },
    [BaseGameType.SLOT_CONFIG_E]: {
        viewports: slotConfigE,
    },
    [BaseGameType.SLOT_CONFIG_F]: {
        viewports: slotConfigF,
    },
    [BaseGameType.SKILL_DICE_CONFIG]: {
        viewports: slotConfigD, // TODO: Use correct config
    },
}

export const BET_STEPPER_CONFIGS: BaseGameType[] = [BaseGameType.SLOT_CONFIG_E, BaseGameType.SLOT_CONFIG_F]

export default gameConfigurations
